import React, { useEffect, useState } from "react";
import './JoinLouieTeam.css'
import illustration from '../../assets/images/illustration.png'
import { db } from "../../config/firebase";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { Firestore } from "firebase/firestore";
export const JoinLouieTeam = ()=> {
  const [jobs, setJobs] = useState([]);
  const [isEmailTemplate, setIsEmailTemplate] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // const jobs = [
  //   {
  //     title: "Job Title",
  //     description: "Small Job Description",
  //     details: "Location | Employment Type",
  //   },
  //   {
  //     title: "Quality Assurance Tester",
  //     description: "Manual Mobile App Testing",
  //     details: "On-Site | Full time",
  //   },
  // ];
  
  // Basic mobile detection
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

  const email = 'hello@louievoice.com';

  const mobileLink = `mailto:${email}`;
  const desktopLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

  useEffect(() => {
    
    const fetchEmailTemplateFlag = async () => {
      setIsLoading(true)
      try {
        const docRef = doc(db, "setting", "emailTemplateConfig");
        const docSnap = await getDoc(docRef);
        const flag = docSnap.exists ? docSnap.data().isEmailTemplate : false
        console.log('flag_is', flag)
        setIsEmailTemplate(flag);
      } catch (error) {
        console.error("Error fetching template flag: ", error);
      }
    }
    const fetchJobs = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "jobs"));
        const jobList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setIsLoading(false)
        setJobs(jobList);
      } catch (err) {
        console.error("Error fetching jobs: ", err);
      }
    };
    fetchEmailTemplateFlag()
    fetchJobs();
  }, []);

  return (
    <>
      <div className="nav-background"></div>
      <div className="join-louie-container">
        <div className="louie-team-content">
          <p className="title">Join Louie Team</p>

          <section className="section">
            <div className="culture">
              <div>
                <p className="subtitle" id="culture-title">Work Culture at Louie Voice</p>
                <p className="purpose">
                  Louie Voice is a purpose driven start-up, aiming to positively impact
                  lives of millions of users across the world.
                </p>
                <p className="purpose1">We can only achieve our purpose if we remain</p>
                <ul className="svg-bullet-list">
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                    </svg>
                    Passionate about our goals
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                    </svg>
                    Passionate and caring about the needs of our users
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                    </svg>
                    Passionate about every Louie Voice execution and ensuring it really
                    works for the end users
                  </li>
                </ul>
                <p className="tall-goals">
                  These tall goals make us a highly driven organization, with
                  exceptional talent building and driving our Voice Interface technology
                  with no direct competitors globally.
                </p>
              </div>
              <div className="illustration">
                <img src={illustration} alt="ill_img" />
              </div>
            </div>
            
          </section>

          <section className="section">
            <h2 className="subtitle">Consider joining the Louie Team</h2>
            <p className="only-if">Only if -</p>
            <ul className="svg-bullet-list">
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                </svg>
                You strongly connect with Louie Voice goals
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                </svg>
                You are extremely smart and a great problem solver. We don't care
                much about fancy titles or experience
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM5.67272 8.5C5.67272 10.0615 6.93854 11.3273 8.5 11.3273C10.0615 11.3273 11.3273 10.0615 11.3273 8.5C11.3273 6.93854 10.0615 5.67272 8.5 5.67272C6.93854 5.67272 5.67272 6.93854 5.67272 8.5Z" fill="#2E3990"/>
                </svg>
                Age is no bar
              </li>
            </ul>
          </section>

          <section className="section">
            <h2 className="subtitle">Current Openings</h2>
            {isLoading? 'Loading...' : <div>{jobs.length>0?(<div className="openings">
              {jobs.map((job, idx) =>{
                  const email = job.email || "hello@louievoice.com";
                  const jobTitle = job.title;

                  const emailBody = isEmailTemplate ? `
                  Hi Team,

                  I would like to apply for the position of ${jobTitle} at Visioapps Technology. Please find my details below:

                  Full Name:    
                  Phone Number:  

                  Current CTC (LPA):  
                  Expected CTC (LPA):  
                  Notice Period (in days):  

                  Total Experience:   
                  Resume Link / Attached:  

                  Looking forward to hearing from you.

                  Thank You.
                  ` : '';
                  // const emailBody = ''

                  const mobileLink = `mailto:${email}?subject=${encodeURIComponent(`Job Application for ${jobTitle}`)}&body=${encodeURIComponent(emailBody)}`;
                  const desktopLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(`Job Application for ${jobTitle}`)}&body=${encodeURIComponent(emailBody)}`;

              
                return (<div className="job-card" key={idx}>
                  <div className="job-info">
                    <p className="job-title">{job.title}</p>
                    <p className="job-description">{job.description}</p>
                    <p className="job-details">{job.details}</p>
                    <a href={job.pdfUrl} target="_blank" className="download-link">
                      Download Full Job Description
                    </a>
                  </div>
                  <div className="job-actions">
                    <p className="email-cv">Email your CV to {email}</p>
                    {/* <a href={job.pdfUrl} target="_blank" className="download-link">
                      Download Full Job Description
                    </a> */}
                    <span className="separator">|</span>
                    {/* <a href="#" className="apply-link">
                      Apply Now
                    </a> */}
                     <a 
                        className="apply-link"
                        href={isMobile ? mobileLink : desktopLink}
                        target={isMobile ? '_self' : '_blank'}
                        rel="noopener noreferrer"
                      >
                       Apply Now
                      </a>
                  </div>
                </div>);
              })}
            </div> ):( 'Currently there are no openings...')}</div>}
          </section>

        </div>
      </div>
    </>

  );
}
